import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function campaignDataReducer(state = initialState.campaignData, action) {
  switch (action.type) {
    case types.LOAD_CAMPAIGN_DATA_SUCCESS:
      return action.campaignData;
    default:
      return state;
  }
}
